import classNames from "classnames";
import InlineLoader from "@/icons/inline-loader.svg";
import ArrowRight from "@/icons/arrow-right-bold.svg";

function OrderNowBtn({ onClick, isLoading, btnText = "Order Now" }) {
  return (
    <button
      className="w-fit px-4 min-[400px]:px-6 py-5  bg-white text-[1rem] lg:text-2xl font-bold rounded-2xl shadow-getPetTagButton relative self-center lg:self-auto hover:bg-[#FED8A9] transition-colors duration-700 leading-6"
      disabled={isLoading}
      onClick={onClick}
    >
      {isLoading && (
        <InlineLoader className="inline-block h-[4rem] w-[4rem] absolute top-[calc(50%_-_2rem)] left-[calc(50%_-_2rem)]" />
      )}
      <div
        className={classNames(
          {
            invisible: isLoading,
          },
          "flex items-center space-x-[8px] lg:space-x-[10px] whitespace-nowrap"
        )}
      >
        <p>{btnText}</p>
        <ArrowRight />
      </div>
    </button>
  );
}

export default OrderNowBtn;
